import router from "@/router";

let isRedirectingToLogin = false;

export default function redirectToLoginWhenSessionExpires() {
  localStorage.setItem("auth", "0");

  const currentRoute = router.currentRoute;
  const isLoginRoute =
    currentRoute && (currentRoute.name === "Login" || currentRoute.path === "/login");

  if (!isLoginRoute && currentRoute && currentRoute.fullPath) {
    localStorage.setItem("redirectPath", currentRoute.fullPath);
  }

  if (isRedirectingToLogin) {
    return;
  }

  sessionStorage.setItem("redirectedLogin", "A sessão expirou. Por favor inicie a sessão novamente.")

  isRedirectingToLogin = true;

  router.push({ name: "Login" }).catch(() => {}).finally(() => {
    isRedirectingToLogin = false;
  });
}
